import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface PrivacySettingsProps {
  isAnonymous: boolean;
  isPrivate: boolean;
  onAnonymousChange: (value: boolean) => void;
  onPrivateChange: (value: boolean) => void;
}

export const PrivacySettings = ({
  isAnonymous,
  isPrivate,
  onAnonymousChange,
  onPrivateChange,
}: PrivacySettingsProps) => {
  return (
    <div className="space-y-4 bg-white/50 backdrop-blur-sm p-4 rounded-xl border border-purple-100">
      <div className="flex items-center justify-between">
        <Label htmlFor="anonymous" className="text-purple-700">Post Anonymously</Label>
        <Switch
          id="anonymous"
          checked={isAnonymous}
          onCheckedChange={onAnonymousChange}
          className="data-[state=checked]:bg-purple-500"
        />
      </div>

      <div className="flex items-center justify-between">
        <Label htmlFor="private" className="text-purple-700">Private Post</Label>
        <Switch
          id="private"
          checked={isPrivate}
          onCheckedChange={onPrivateChange}
          className="data-[state=checked]:bg-purple-500"
        />
      </div>
    </div>
  );
};